import { render, staticRenderFns } from "./huanbao.vue?vue&type=template&id=b1f1e672&"
import script from "./huanbao.vue?vue&type=script&lang=js&"
export * from "./huanbao.vue?vue&type=script&lang=js&"
import style0 from "./huanbao.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports